// extracted by mini-css-extract-plugin
export default {"containerLoader":"loader_containerLoader__RJVLo","loader":"loader_loader__WqiCD","invisibleLoader":"loader_invisibleLoader__ABt2+","mulShdSpin":"loader_mulShdSpin__QFr4s"};